const Vars = {
  refreshInterval: 2000,
};

export default Vars;
